// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__5PCBM","search":"Settings_search__3bNL_","filter":"Settings_filter__1Uo4I"};